import { Accordion, Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";


import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import DataTable from "react-data-table-component";
import avatar1 from "../../../assets/images/avatars/01.png"
import ExpenseViewModal from "./ExpenseViewModal";
import { useSearchParams } from "react-router-dom";
import { allUsersSignal } from "../../../signal/allUsersSignal";
import { saveAs } from "file-saver";

export default function ExpenseList() {

    let today = Date.now();
    // get date start Time of 7 days ago in milliseconds
    let sevenDaysAgo = new Date(today - 7 * 24 * 60 * 60 * 1000).getTime();

    const [searchParams, setSearchParams] = useSearchParams();
    const [expenses, setExpenses] = useState([]);
    const [expenseToDisplay, setExpenseToDisplay] = useState([]);
    const [fromDate, setFromDate] = useState(searchParams.get("fromDate") ? searchParams.get("fromDate") : moment(sevenDaysAgo).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(searchParams.get("toDate") ? searchParams.get("toDate") : moment(today).format("YYYY-MM-DD"));
    const [search, setSearch] = useState("");
    const [text, setText] = useState({})
    const [showExpenseViewModal, setShowExpenseViewModal] = useState(false);
    const [selectedExpense, setSelectedExpense] = useState(null);
    const [maxAmount, setMaxAmount] = useState(searchParams.get("maxAmount") ? parseFloat(searchParams.get("maxAmount")) : 0);
    const [minAmount, setMinAmount] = useState(searchParams.get("minAmount") ? parseFloat(searchParams.get("minAmount")) : 0);
    const [statusFilter, setStatusFilter] = useState(searchParams.get("statusFilter") ? searchParams.get("statusFilter") : "");

    const handleDisplayFields = () => {
        setExpenseToDisplay(expenses.filter((item) => {

            if (minAmount && item.amount < minAmount) return false;
            if (maxAmount && item.amount > maxAmount) return false;
            if ((statusFilter && statusFilter !== "") && item.status !== statusFilter) return false;
            if (search === "") return true;
            if (item.title.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.description.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.amount.toString().includes(search.toLowerCase())) {
                return true;
            } else if (item.userId?.length > 0 && item.userId[0].name.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.status.toLowerCase().startsWith(search.toLowerCase())) {
                return true;
            } else if (item.reviewedBy?.length > 0 && item.reviewedBy[0].name.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.reason.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (moment(item.createdAt).format("DD/MM/YY hh:mm").includes(search.toLowerCase())) {
                return true;
            }
            return false;
        }))
    }

    const refetchExpenses = () => {
        getExpenses.refetch({ cancelRefetch: true });
    }

    const handleFilters = async () => {
        const tempSearchParam = new URLSearchParams({ fromDate: fromDate, toDate, minAmount, maxAmount, statusFilter });
        setSearchParams(tempSearchParam);
        await getExpenses.refetch({ cancelRefetch: true });
        handleDisplayFields();
    }

    useEffect(() => {
        handleDisplayFields();
    }, [search, expenses])

    const getExpenses = useQuery("expenses", async () => {
        let resp = await axios.get(`${DEV_SERVER}/expense/v2?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 59)}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                let stateName = window.localStorage.getItem("state");
                let temp = data.data

                if (stateName) {
                    temp = temp.filter((item) => {
                        if (item?.userId?.length > 0 && allUsersSignal.value[item?.userId[0]?.id]?.state === stateName) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                }

                setExpenses(temp);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const updateExpenseStatusMutation = useMutation((data) => axios.post(`${DEV_SERVER}/expense/v2/updateStatus/${data.id}`, data.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                refetchExpenses();
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    let updateExpenseStatus = (id, status, reason) => {
        updateExpenseStatusMutation.mutate({ id, body: { status, reason } })
    }

    useEffect(() => {
        refetchExpenses();
    }, [])

    const handleRowClick = (row) => {
        setSelectedExpense(row);
        setShowExpenseViewModal(true);
    }

    const columns = [
        {
            name: "Title",
            color: true,
            center: true,
            selector: "title",
        },
        {
            name: "Description",
            color: true,
            center: true,
            selector: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.description}</Tooltip>}><span onClick={() => handleRowClick(row)}>{row?.description}</span></OverlayTrigger>

            },
        },
        {
            name: "Amount",
            color: true,
            center: true,
            selector: "amount",
            cell: (row) => `₹ ${parseFloat(row?.amount).toFixed(2)}`,
            sortable: true,
        },
        {
            name: "Date",
            color: true,
            center: true,
            selector: "createdAt",
            cell: (row) => moment(row?.createdAt).format("DD/MM/YY hh:mm A"),
            sortable: true,
        },
        {
            name: "Media",
            color: true,
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                {row?.media?.length > 0 && row?.media?.map((m) =>
                    <Zoom key={m._id}><img src={m.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px" }} /></Zoom>

                )}
            </div>
        },
        {
            name: "User",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.userId?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.userId[0]?.name}</Tooltip>}>
                        <span onClick={() => handleRowClick(row)} style={{ display: "flex", columnGap: "0.5rem", alignItems: "center" }}>
                            <img style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={row?.userId[0].profileURL !== "" ? row?.userId[0].profileURL : avatar1} />
                            {row?.userId[0].name}
                        </span>
                    </OverlayTrigger>
                } else {
                    return "NA"
                }
            }
        },
        {
            name: "Status",
            color: true,
            center: true,
            selector: (row) => <span style={{ color: row?.status === "pending" ? "orange" : (row?.status === "approved" ? "green" : "red") }}>{row?.status}</span>
        },
        {
            name: "Reviewed By",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.reviewedBy?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.reviewedBy[0]?.name}</Tooltip>}>
                        <span onClick={() => handleRowClick(row)}>{row?.reviewedBy[0].name}</span>
                    </OverlayTrigger>
                }
                return "NA"
            }
        },
        {
            name: "Reason",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.status === "pending") {
                    return <textarea style={{ width: "100%" }} value={text[row?.id] || ""} onChange={(e) => setText({ ...text, [row?.id]: e.target.value })} ></textarea>
                } else {
                    return row?.reason === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.reason}</Tooltip>}><span>{row?.reason}</span></OverlayTrigger>
                }
            }
        },
        {
            name: "Action",
            color: true,
            center: true,
            selector: (row) => <span style={{ display: "flex", alignItems: "center", justifyContent: "center", columnGap: "0.8rem", opacity: row?.status === "pending" ? 1 : 0.5 }}>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Reject</Tooltip>}><i onClick={(e) => updateExpenseStatus(row?.id, "rejected", text[row?.id])} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "red" }} class="fas fa-times"></i></OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Approve</Tooltip>}><i onClick={(e) => updateExpenseStatus(row?.id, "approved", text[row?.id])} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "green" }} class="fas fa-check"></i></OverlayTrigger>
            </span>
        },
        {
            name: "Location",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.location?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View on Map</Tooltip>}><a href={`https://www.google.com/maps/search/?api=1&query=${row?.location[0]},${row?.location[1]}`} target="_blank" ><i class="fas fa-map-marker-alt"></i></a></OverlayTrigger>
                }
                return "NA"
            }
        }
    ]

    // Add export handler
    const handleExport = async () => {
        try {
            // Build query params from current filters
            const params = new URLSearchParams({
                fromDate,
                toDate,
                minAmount,
                maxAmount,
                statusFilter,
            });

            const resp = await axios.get(
                `${DEV_SERVER}/report/v2/expense/expense-report?${params.toString()}`,
                {
                    headers: {
                        Authorization: `Bearer ${userSignal.value?.token}`,
                    },
                    responseType: "blob",
                }
            );
            const contentDisposition = resp.headers['content-disposition'];
            let filename = "expense-report.xlsx";
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) filename = match[1];
            }
            saveAs(resp.data, filename);
            toast.success("Expense report downloaded!", { autoClose: 2000 });
        } catch (err) {
            toast.error("Failed to export expense report");
        }
    };

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Expense List</h4>
                                </div>
                                {/* Export Button */}
                                <button className="btn btn-success" onClick={handleExport}>
                                    {/* SVG Export Icon */}
                                    <span style={{ display: "inline-flex", verticalAlign: "middle", marginRight: "6px" }}>
                                        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 18765 21993">
                                            <path fillRule="nonzero" d="M4317 0l9063 0c285,0 530,102 731,303l4351 4350c201,202 303,447 303,732l0 13155c0,910 -742,1652 -1653,1652l-11137 0c-53,0 -98,-28 -123,-75 -24,-46 -20,-99 10,-142l777 -1104c26,-38 66,-59 112,-59l10361 0c150,0 273,-123 273,-272l0 -12943 -2764 0c-801,0 -1454,-653 -1454,-1454l0 -2763 -8850 0c-150,0 -273,123 -273,272l0 10524c0,75 -62,137 -138,137l-1104 0c-76,0 -138,-62 -138,-137l0 -10524c0,-910 742,-1652 1653,-1652zm2039 17106l-1288 0c-159,0 -288,-129 -288,-288l0 -3424c0,-158 -129,-287 -288,-287l-2339 0c-159,0 -288,129 -288,287l0 3424c0,159 -129,288 -288,288l-1288 0c-110,0 -205,58 -255,155 -51,98 -44,209 20,299l3033 4311c56,79 139,122 235,122 97,0 180,-43 236,-122l3033 -4311c64,-90 71,-201 20,-299 -50,-97 -145,-155 -255,-155zm-394 -12701l3588 0c107,0 194,88 194,195l0 775c0,107 -87,194 -194,194l-3588 0c-107,0 -194,-87 -194,-194l0 -775c0,-107 87,-195 194,-195zm970 3727l0 2150 4056 0 0 -2150 -4056 0zm0 3314l0 2150 4056 0 0 -2150 -4056 0zm5220 -1164l2345 0 0 -2150 -2345 0 0 2150zm2345 1164l-2345 0 0 2150 2345 0 0 -2150zm1164 -3509l0 2539 0 775 0 2539 0 355 0 420c0,107 -87,194 -194,194l-9505 0c-107,0 -194,-87 -194,-194l0 -420 0 -355 0 -2539 0 -775 0 -2539 0 -355 0 -420c0,-107 87,-194 194,-194l9505 0c107,0 194,87 194,194l0 420 0 355z" fill="white"></path>
                                        </svg>
                                    </span>
                                    Export
                                </button>
                            </Card.Header>
                            <Card.Body>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header><b>Filters</b></Accordion.Header>
                                        <Accordion.Body>
                                            <div className="flex-wrap" style={{ display: "flex", alignItems: "center", columnGap: "1rem", marginBottom: "1rem" }}>
                                                <div>
                                                    <label htmlFor="fromDate">From Date</label>
                                                    <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" value={fromDate} onChange={(e) => {
                                                        setFromDate(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="toDate">To Date</label>
                                                    <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" value={toDate} onChange={(e) => {
                                                        setToDate(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="minAmount">Min Amount</label>
                                                    <input type="number" id="minAmount" className="form-control vanila-datepicker" names="start" placeholder="Min Amount" value={minAmount} onChange={(e) => {
                                                        setMinAmount(e.target.value)

                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="maxAmount">Max Amount</label>
                                                    <input type="number" id="maxAmount" className="form-control vanila-datepicker" names="start" placeholder="Max Amount" value={maxAmount} onChange={(e) => {
                                                        setMaxAmount(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="statusFilter">Status</label>
                                                    <select value={statusFilter} onChange={(e) => {
                                                        setStatusFilter(e.target.value);
                                                    }} className="form-control">
                                                        <option value="">All</option>
                                                        <option value="pending">Pending</option>
                                                        <option value="approved">Approved</option>
                                                        <option value="rejected">Rejected</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end" style={{ columnGap: '1rem' }}>
                                                <button className="btn btn-light ms-2" onClick={() => {
                                                    setFromDate(moment(sevenDaysAgo).format("YYYY-MM-DD"));
                                                    setToDate(moment(today).format("YYYY-MM-DD"));
                                                    setMinAmount(0);
                                                    setMaxAmount(0);
                                                    setStatusFilter("");
                                                    const tempSearchParam = new URLSearchParams({ fromDate: moment(sevenDaysAgo).format("YYYY-MM-DD"), toDate: moment(today).format("YYYY-MM-DD"), minAmount: 0, maxAmount: 0, statusFilter: "" });
                                                }}>Reset</button>
                                                <button className="btn btn-primary" onClick={handleFilters}>Apply changes</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                <div className="mt-2" style={{ display: "flex", alignItems: "end", justifyContent: "flex-end", columnGap: "1rem", marginBottom: "1rem" }}>
                                    <div>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => {
                                            setSearch(e.target.value)
                                        }} />
                                    </div>
                                </div>
                                {(!getExpenses.isLoading && !getExpenses?.isFetching) &&
                                    <DataTable
                                        customStyles={{
                                            rows: {
                                                style: {
                                                    cursor: "pointer",
                                                    backgroundColor: "unset"
                                                }
                                            }
                                        }}
                                        onRowClicked={(row) => {
                                            handleRowClick(row);
                                        }}
                                        columns={columns}
                                        data={expenseToDisplay}
                                        pagination={true}
                                        paginationPerPage={35}
                                        paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}
                                    />
                                }
                                {(getExpenses.isLoading || getExpenses?.isFetching) && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {showExpenseViewModal && <ExpenseViewModal updateExpenseStatus={updateExpenseStatus} expense={selectedExpense} show={showExpenseViewModal} close={() => setShowExpenseViewModal(false)} />}
        </>
    )
}